// @ts-nocheck
import { PlusOutlined, YoutubeOutlined } from "@ant-design/icons";
import Card from "../Card";
import { Button } from "antd";
import { useCallback } from "react";
// @ts-ignore
import useHttpClient from "../../hooks/useHttpClient";
// @ts-ignore
import { useRedirect } from "../../hooks/useRedirect";
import { App } from "antd";
import useUser from "/src/hooks/useUser";
// @ts-ignore
import Table from "../Table";
import { captureException } from "@sentry/react";
import { IS_WHITE_LABEL } from "../../constants";
import useOrg from "../../hooks/apis/useOrg";
import useOrgTerminology from "../../hooks/useOrgTerminology";

const ChannelsCard = () => {
  const { data, isLoading: loading, error } = useUser();
  const { data: org } = useOrg();
  const terminology = useOrgTerminology();
  const isWhiteLabel = org?.config?.whiteLabel ?? IS_WHITE_LABEL;
  const httpClient = useHttpClient();
  const redirect = useRedirect();
  const { modal, message } = App.useApp();
  const fetchFn = useCallback(async () => ({ data: data?.channels ?? [] }), [data]);

  const abbreviateUrl = (url: string, maxLength = 50) => {
    if (!url || url.length <= maxLength) {
      return url;
    }
    const start = Math.floor(maxLength / 2) - 2;
    const end = url.length - Math.floor(maxLength / 2) + 2;
    return `${url.substring(0, start)}...${url.substring(end)}`;
  };

  const columns = [
    {
      title: "عنوان ",
      key: "title",
    },
    {
      key: "url",
      title: "آدرس",
      render: (value: string) => (
        <a href={value} target="_blank" rel="noopener noreferrer">
          {abbreviateUrl(value, 25)}
        </a>
      ),
    },
    isWhiteLabel
      ? {}
      : {
          key: "actions",
          render: (_: any, { state, id, title }: { state: string; id: string; title: string }) => {
            if (
              [
                "INITIAL",
                "CANCELLED",
                "ICE_BOX",
                "FOR_FUTURE",
                "CONTENT_REVIEW",
                "ACCESS_OR_SCREEN",
              ].includes(state)
            ) {
              return (
                <Button size="small" onClick={handleDelete}>
                  حذف
                </Button>
              );
            }

            function handleDelete() {
              modal.confirm({
                title: "حذف کانال",
                content: `از حذف کانال ${title} اطمینان دارید؟`,
                onOk: () =>
                  httpClient
                    .delete(`/channels/${id}`)
                    .then(() => {
                      document.location.reload();
                    })
                    .catch((e: any) => {
                      captureException(e);
                      message.error("خطا هنگام حذف کانال، لطفا با پشتیبانی تماس بگیرید");
                    }),
              });
            }
          },
        },
  ];

  function handleAddChannel() {
    httpClient
      .post("/auth/oauth2/permission", {
        permissions: ["youtube.readonly", "youtubepartner-channel-audit"].join(","),
        redirectUri: `${window.location.origin}/auth/callback`,
      })
      .then(
        ({
          data: {
            data: { redirectUrl },
          },
        }) => {
          redirect(redirectUrl);
        }
      );
  }

  return (
    <Card
      title={terminology.channelsMenuLabel}
      Icon={YoutubeOutlined}
      actions={
        isWhiteLabel ? undefined : (
          <Button icon={<PlusOutlined />} size="small" onClick={handleAddChannel}>
            افزودن کانال جدید
          </Button>
        )
      }
      className="flex-grow"
    >
      <Table
        columns={columns}
        className="mt-4"
        fetchFn={fetchFn}
        rowKey="title"
        pagination={false}
      />
    </Card>
  );
};

export default ChannelsCard;
